import React from 'react';
import styled from 'styled-components';
import ReactSelect from '~/components/ReactSelect';
import useStore from '~/store';
import { sheets } from '~/../config.json';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 48%;
  max-width: 250px;
`;

const setCurrentSheetSelector = (s) => s.setCurrentSheet;
const setLoadingSelector = (s) => s.setLoading;
const options = sheets.map((sheet) => ({ value: sheet.id, label: sheet.name, group: sheet.group }));

export default function SheetSelect({ side }) {
  const currentSheet = useStore((s) => s[`${side}Sheet`]);
  const setCurrentSheet = useStore(setCurrentSheetSelector);
  const setLoading = useStore(setLoadingSelector);

  const handleSheetChange = (option) => {
    const sheet = config.sheets.find((s) => s.id === option.value);
    if (sheet) {
      setLoading(true, side);
      setCurrentSheet(sheet, side);
    }
  };

  return (
    <Wrapper>
      <ReactSelect
        options={options}
        value={{ value: currentSheet.id, label: currentSheet.name }}
        onChange={handleSheetChange}
      />
    </Wrapper>
  );
}
